export interface PoseData {
  type: 'pose_data';
  keypoints: [number, number, number][];
  score: number;
  feedback: string[];
  reps: number;
  duration: number;
  exercise: string;
  angles: Record<string, number>;
  frame: string | null;
  mask?: string | null;   // base64 PNG segmentation mask (quarter resolution)
  demo?: boolean;
}

export const SKELETON_CONNECTIONS: [number, number][] = [
  [5, 6],
  [5, 11],
  [6, 12],
  [11, 12],
  [5, 7],
  [7, 9],
  [6, 8],
  [8, 10],
  [11, 13],
  [13, 15],
  [12, 14],
  [14, 16],
  [0, 5],
  [0, 6],
];
